import { Component, OnInit, Input } from '@angular/core';
import { IField } from 'app/profile/models/dynamic-form.model';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'form-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit {
    @Input() dateFormControl;
    @Input() field: IField;
    @Input() formData;
    selectedDate: Date;

    constructor() {}

    ngOnInit(): void {}
}
